import { html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {ifDefined} from "lit-html/directives/if-defined";

export default class SearchFilterItem extends OutlineElement {
  static get properties() {
    return {
      facetId: { type: String },
      label: { type: String },
      type: { type: String },
      value: { type: Number },
      isActive: { type: Boolean },
      count: { type: Number },
    };
  }

  constructor() {
    super();
    this.facetId = '';
    this.label = '';
    this.value = 0;
    this.count = 0;
    this.isActive = false;
    this.type = 'checkbox';
  }

  toggleFilter(e) {
    e.preventDefault();
    this.isActive = !this.isActive;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const filterString = `${this.facetId}:${this.value}`;
    let activeFilterKeys = this.getFilterParams(urlParams);

    activeFilterKeys.forEach(item => {
      if (urlParams.has(item.key)) {
        urlParams.delete(item.key);
      }
    });

    activeFilterKeys = activeFilterKeys.filter(
      item => item.value !== filterString
    );
    if (this.isActive) {
      activeFilterKeys.push({ key: 'new', value: filterString });
    }

    activeFilterKeys.forEach((item, index) => {
      urlParams.set(`f[${index}]`, item.value);
    });

    // If the page param is set, we also need to clear it when changing
    // the active filter set.
    if (urlParams.has('page')) {
      urlParams.delete('page');
    }

    window.location.href = `/search?${urlParams.toString()}`;
  }

  getFilterParams(paramList) {
    const result = [];
    const re = /f\[(\d+)\]/s;

    paramList.forEach((value, key) => {
      const m = key.match(re);
      if (m) {
        result.push({ key, value });
      }
    });

    return result;
  }

  render() {
    return html`
      <hf-checkbox
        styleclass="search-filter"
        type="${this.type}"
        .checked="${this.isActive}"
        label="${this.label}"
        disabled=${ifDefined(this.count === 0 ? 'disabled' : undefined)}
        @click="${this.toggleFilter}"
      >
      </hf-checkbox>
    `;
  }
}
customElements.define('hf-search-filter-item', SearchFilterItem);
